module.exports = __webpack_public_path__ + "img/forbes_argentina.657ec66c.jpg";